
  export default {
    props: {
      label: { type: String, required: true },
      modelName: { type: String, required: true },
      field: { type: String, required: true }
    },
    computed: {
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field);
        },
        set (value) {
          const h = {};
          h[this.field] = value;
          this.$formSet(this.modelName, h);
        }
      }
    }
  };
